import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import { useHistory } from 'react-router-dom'
import { Select, Input, authenticationService, Help } from '@enkla-gui'

export default function Register() {
  const { register, handleSubmit } = useForm()
  const history = useHistory()
  const [error, setError] = useState(null)
  const [modal, setModal] = useState(null)
  const [cookieModal, setCookieModal] = useState(null)
  const [registering, setRegistering] = useState(false)

  if (authenticationService.currentTokenValue !== null) history.push('/dashboard')
  var onSubmit = data => {
    setRegistering(true)
    authenticationService
      .register({ ...data, tos_accepted: true })
      .then(user => {
        history.push({
          pathname: '/login',
          message: 'Kontot registrerat, vi har skickat ett mail med länk för verifiering av e-post'
        })
      })
      .catch(([error, res]) => {
        setRegistering(false)
        setError({
          message: res.message,
          data: res.data
        })
      })
  }

  return (
    <div className='full-height register-page'>
      <div className='register-card'>
        <div className='register-card-inner'>
          <div className='register-info'>
            <div className='register-info-content'>
              <span className='register-info-badge'>30 dagar gratis</span>
              <h2>Registrera ditt konto</h2>
              <p className='register-info-subtitle'>Prova Enkla Fastigheter i 30 dagar – helt kostnadsfritt</p>
              <div className='register-accent-line' />
              <ul className='register-info-list'>
                <li><i className='fas fa-check' />Ingen kort- eller betalinformation behövs</li>
                <li><i className='fas fa-check' />Alla funktioner är tillgängliga under hela testperioden</li>
                <li><i className='fas fa-check' />Avgör i praktiken om systemet passar dina behov</li>
              </ul>
              <p className='register-info-note'>
                Testperioden avslutas automatiskt efter 30 dagar. Vill du fortsätta aktiverar du enkelt betalning via kort eller faktura. Ingen bindningstid eller uppsägningstid.
              </p>
            </div>
          </div>
          <div className='register-form-section'>
            <form onSubmit={handleSubmit(onSubmit)}>
              {error && <Help type='danger' icon='fas fa-exclamation' header={false}>{error.message}</Help>}
              <Select
                noInitialValue
                controls={{ register }}
                name='billable.organisation'
                options={{ required: true }}
                label='Kundtyp'
                values={[
                  { value: 1, key: 'Företagskund' },
                  { value: 0, key: 'Privatkund' }
                ]}
              />
              <div className='row'>
                <Input
                  controls={{ register }}
                  name='user.name'
                  options={{ required: true }}
                  label='Ditt Namn'
                  error={error}
                  cols='col-lg-6 col-12'
                />
                <Input
                  controls={{ register }}
                  name='billable.name'
                  options={{ required: true }}
                  label='Verksamhetsnamn'
                  error={error}
                  cols='col-lg-6 col-12'
                />
              </div>
              <Input
                controls={{ register }}
                name='billable.phone'
                options={{ required: false }}
                label='Telefonnummer'
                type='tel'
                error={error}
              />
              <Input
                controls={{ register }}
                name='user.email'
                options={{ required: true }}
                label='E-post'
                error={error}
              />
              <div className='row'>
                <Input
                  controls={{ register }}
                  name='user.password'
                  options={{ required: true }}
                  label='Lösenord'
                  type='password'
                  error={error}
                  cols='col-lg-6 col-12'
                />
                <Input
                  controls={{ register }}
                  name='user.password_confirmation'
                  options={{ required: true }}
                  label='Upprepa Lösenord'
                  type='password'
                  error={error}
                  cols='col-lg-6 col-12'
                />
              </div>
              <div className='mb-3'>
                {!registering ? (
                  <button type='submit' className='btn register-btn'>Registrera</button>
                ) : (
                  <button type='submit' disabled className='btn register-btn'>
                    <i className='fas fa-circle-notch fa-spin' /> Skapar konto...
                  </button>
                )}
              </div>
              <p className='register-terms'>
                Genom att klicka på <strong>Registrera</strong> godkänner du{' '}
                <a href='https://enklafastigheter.se/tos' target='_blank' rel='noreferrer'>användaravtalet</a>
                {' '}och{' '}
                <a href='https://enklafastigheter.se/integrity' target='_blank' rel='noreferrer'>integritetspolicyn</a>.
              </p>
            </form>
            <p className='register-login-link'>
              Har du redan ett konto? <a href='#/login'>Logga in istället</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}
